module.exports = __webpack_public_path__ + "static/media/3.701047dc.jpg";